import type { QuickPrefs } from '@ehr/shared';

/**
 * ehr#571 (PROGRESS_NOTE_10-20-V141 V131): the Remove question on a Quick add section has three
 * scopes past "This note only". This client going forward takes the item out of this client's own
 * Quick add list, made from the all-clients list when the client had none; All clients going
 * forward takes it out of the all-clients list and every client's own. Saved and signed notes never
 * change. Null when the item isn't on the list(s) the scope covers, so there is nothing to save.
 */
export function quickWithout(
  prefs: QuickPrefs,
  id: string,
  scope: 'client' | 'all',
  contactId: string,
): QuickPrefs | null {
  if (scope === 'client') {
    const list = prefs.clients[contactId] ?? prefs.onNote;
    if (!list.includes(id)) return null;
    return { ...prefs, clients: { ...prefs.clients, [contactId]: list.filter((x) => x !== id) } };
  }
  const inLists =
    prefs.onNote.includes(id) || Object.values(prefs.clients).some((l) => l.includes(id));
  if (!inLists) return null;
  return {
    ...prefs,
    onNote: prefs.onNote.filter((x) => x !== id),
    clients: Object.fromEntries(
      Object.entries(prefs.clients).map(([c, l]) => [c, l.filter((x) => x !== id)]),
    ),
  };
}
